import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image
          src="https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763462843/Creative_Twinning_naslovna_mdxhhd.jpg"
          alt="Panoramic view of Serbian mountain landscape with ancient monastery nestled in green valley under dramatic cloudy sky"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          {/* Main Title */}
          <div className="space-y-4">
            <h1 className="font-heading font-bold text-4xl sm:text-5xl lg:text-7xl text-white leading-tight">
              Creative Twinning
            </h1>
            <h2 className="font-heading font-semibold text-2xl sm:text-3xl lg:text-4xl text-white/90 leading-tight">
              Kreativna Saradnja
            </h2>
          </div>

          {/* Subtitle */}
          <p className="max-w-3xl mx-auto text-lg sm:text-xl lg:text-2xl text-white/90 leading-relaxed">
            Discover the rich cultural heritage and breathtaking natural beauty of Serbia and Montenegro through immersive thematic trails that connect history, tradition, and adventure.
          </p>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <Link to="/thematic-trails-overview">
              <Button
                variant="default"
                size="lg"
                className="bg-accent hover:bg-accent/90 text-accent-foreground px-8 py-4 text-lg font-semibold shadow-lg"
                iconName="Map"
                iconPosition="left">

                Explore Trails
              </Button>
            </Link>
            <Link to="/heritage-interactive-map">
              <Button
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-primary px-8 py-4 text-lg font-semibold"
                iconName="MapPin"
                iconPosition="left">

                Heritage Map
              </Button>
            </Link>
          </div>

          {/* Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <Icon name="ChevronDown" size={32} color="white" className="opacity-70" />
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;